import React, { createContext, useContext } from 'react';
import { useSectionAnimation } from '../hooks/use-section-animation';

const SectionAnimationContext = createContext();

export const useSectionAnimationContext = () => {
  const context = useContext(SectionAnimationContext);
  if (!context) {
    throw new Error('useSectionAnimationContext must be used within a SectionAnimationProvider');
  }
  return context;
};

export const SectionAnimationProvider = ({ children }) => {
  const sectionAnimation = useSectionAnimation();

  return (
    <SectionAnimationContext.Provider value={sectionAnimation}>
      {children}
    </SectionAnimationContext.Provider>
  );
};